'use strict';

var imagePlaceholder = require('./image-placeholder-e681e8b9.js');

/* eslint-disable no-param-reassign */
var setImagePlaceholder = function (event) {
    event.currentTarget.src = imagePlaceholder.img;
};

exports.setImagePlaceholder = setImagePlaceholder;
